import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'tracker-admin-commit-actions',
  template: require('./admin.commit.actions.component.html')
})
export class TrackerAdminCommitActionsComponent implements OnInit {
  @Input() tracker: any;
  @Input() roles: any;
  @Input() selectFields: any;

  rolesToReassignLabel: string;
  commitActionChangeFieldLabel: string;
  commitActionChangeElementLabel: string;
  commitTriggerElements: any = [];

  ngOnInit() {
    this.setTrackerCommitReassignLabel();
    this.setCommitActionChangeFieldLabel();
    this.setCommitActionChangeElementLabel();

    this.rolesToReassignLabel = "None";
    this.commitActionChangeFieldLabel = "None";
    this.commitActionChangeElementLabel = "None";
    this.commitTriggerElements = _.get(this.tracker, 'rel.commit_actions.tracker_commit_trigger.trackerExtraField.fieldElements', []);
  }

  updateRoleToReassign(role: any) {
    if (_.find(this.tracker.rel.commit_actions.tracker_commit_reassign, (roleToReassign: any) => roleToReassign.role.id === role.id)) {
      // Role was found, remove it
      _.remove(this.tracker.rel.commit_actions.tracker_commit_reassign, (roleToReassign: any) => roleToReassign.role.id === role.id);
    } else {
      if (role.id === 0) this.tracker.rel.commit_actions.tracker_commit_reassign = [];
      this.tracker.rel.commit_actions.tracker_commit_reassign.push({ role: role });
    }

    this.removeNone(this.tracker.rel.commit_actions.tracker_commit_reassign, true);
    this.setTrackerCommitReassignLabel();
  }

  setCommitActionChangedField(field: any) {
    this.tracker.rel.commit_actions.tracker_commit_trigger = {
      trackerExtraField: _.cloneDeep(field),
      trackerExtraFieldElement: null
    };

    this.setCommitActionChangeFieldLabel();
    this.setCommitActionChangeElementLabel();

    this.commitTriggerElements = _.get(this.tracker, 'rel.commit_actions.tracker_commit_trigger.trackerExtraField.fieldElements', []);
  }

  setCommitActionChangedElement(element: any) {
    element.elementName = element.label;
    this.tracker.rel.commit_actions.tracker_commit_trigger.trackerExtraFieldElement = _.cloneDeep(element);

    this.setCommitActionChangeElementLabel();
  }

  private setTrackerCommitReassignLabel() {
    this.rolesToReassignLabel = _.map(this.tracker.rel.commit_actions.tracker_commit_reassign, (roleToReassign: any) => roleToReassign.role.roleName).join(', ');
    if (this.rolesToReassignLabel === "") this.rolesToReassignLabel = "None";
  }

  private setCommitActionChangeFieldLabel() {
    this.commitActionChangeFieldLabel = (!_.isEmpty(this.tracker.rel.commit_actions.tracker_commit_trigger) && !_.isEmpty(this.tracker.rel.commit_actions.tracker_commit_trigger.trackerExtraField)) ? this.tracker.rel.commit_actions.tracker_commit_trigger.trackerExtraField.fieldName : "";
    if (this.commitActionChangeFieldLabel === "") this.commitActionChangeFieldLabel = "None";
  }

  private setCommitActionChangeElementLabel() {
    this.commitActionChangeElementLabel = (!_.isEmpty(this.tracker.rel.commit_actions.tracker_commit_trigger) && !_.isEmpty(this.tracker.rel.commit_actions.tracker_commit_trigger.trackerExtraFieldElement)) ? this.tracker.rel.commit_actions.tracker_commit_trigger.trackerExtraFieldElement.elementName : "";
    if (this.commitActionChangeElementLabel === "") this.commitActionChangeElementLabel = "None";
  }

  private removeNone(arrElements: any[], isRole: boolean) {
    if (arrElements.length <= 1) return;

    if (isRole) {
      _.remove(arrElements, (element: any) => element.id === 0);
    } else {
      _.remove(arrElements, (element: any) => element.alias === "");
    }
  }

  protected isRoleReassigned(role: any) {
    if (_.isEmpty(role)) {
        return false;
    }
    
    if (_.find(this.tracker?.rel?.commit_actions?.tracker_commit_reassign ?? null, (roleToReassign: any) => {
        return (_.get(roleToReassign, 'role.id', 0) == role.id) ? true : false;
    })) {
        return true;
    }
    
    return false;
  }
}
